import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../utils/api_instance.util";
import { errorToastify } from "../utils/toastify.util";

const initialState = {
    isLoader: false,
    challengeList: [],
    challengeDetails: null,
    challengeItems: null
};

export const getChallengeList = createAsyncThunk(
    "challenge/getChallengeList",
    async (payload) => {
        try {
            const { data } = await instance.post(`/api/v1/game/fetchAllChallengeList`, payload);
            return data;
        } catch (err) {
            const { data } = err.response;
            errorToastify(data.message);
        }
    }
);

export const getChallengeItemList = createAsyncThunk(
    "challenge/getChallengeItemList",
    async (payload) => {
        try {
            const { data } = await instance.post(`/api/v1/game/getChallengeItemList`, payload);
            return data;
        } catch (err) {
            const { data } = err.response;
            errorToastify(data.message);
        }
    }
);

const challengeSlice = createSlice({
    name: "challenge",
    initialState,
    reducers: {
        setChallengeDetails: (state, { payload }) => {
            state.challengeDetails = payload;
        },
        setChallengeItems: (state, { payload }) => {
            state.challengeItems = payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getChallengeList.pending, (state, action) => {
            state.isLoader = true;
        });
        builder.addCase(getChallengeList.fulfilled, (state, action) => {
            if (action.payload?.success || false) {
                state.isLoader = false;
                state.challengeList = action.payload.result;
            } else {
                state.isLoader = false;
                state.challengeList = [];
            }
        });

        builder.addCase(getChallengeItemList.pending, (state, action) => {
            state.challengeItems = [];
        });
        builder.addCase(getChallengeItemList.fulfilled, (state, action) => {
            if (action.payload?.success || false) {
                state.challengeItems = action.payload.result;
            } else {
                state.challengeItems = [];
            }
        });
    },
})

export default challengeSlice.reducer;
export const { setChallengeDetails, setChallengeItems } = challengeSlice.actions;